import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryProductionSystem = () => {
  return <CategoryBase baseEndpoint="category_production_system" />;
};

export default CategoryProductionSystem;
